import * as React from "react";
import { cn } from "@/lib/utils";

interface ExploreSideCardHeaderV2Props {
  title: React.ReactNode;
  icon?: React.ReactNode;
  titleRight?: React.ReactNode;
  rightSlot?: React.ReactNode;
  className?: string;
}

export function ExploreSideCardHeaderV2({
  title,
  icon,
  titleRight,
  rightSlot,
  className,
}: ExploreSideCardHeaderV2Props) {
  return (
    <div className={cn("flex min-h-7 min-w-0 items-center justify-between gap-1.5", className)}>
      <div className="flex min-w-0 items-center gap-1.5">
        {icon ? (
          <span className="grid h-3.5 w-3.5 shrink-0 place-items-center">{icon}</span>
        ) : null}
        <span className="truncate text-[12px] font-medium leading-tight">{title}</span>
        {titleRight ? <div className="flex shrink-0 items-center self-center">{titleRight}</div> : null}
      </div>
      {rightSlot ? (
        <div className="flex h-7 w-7 shrink-0 items-center justify-center">{rightSlot}</div>
      ) : (
        <div aria-hidden className="h-7 w-7 shrink-0" />
      )}
    </div>
  );
}
